import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content, images } from '../mockData';

const HeroSection = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const heroContent = content[language].hero;

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  const scrollToNext = () => {
    const nextSection = document.getElementById('vision');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="video-hero" id="hero">
      {/* Video Background - Placeholder for now */}
      <div className="video-background" style={{ background: '#1a1a1a' }}>
        <img 
          src={images.hero.placeholder} 
          alt="Tenuta Scerni" 
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
      </div>
      
      <div className="video-overlay" />

      {/* Hero Content */}
      <div 
        className={`hero-content fade-in ${isVisible ? 'visible' : ''}`}
      >
        <h1 style={{ color: '#ffffff', marginBottom: '20px', lineHeight: 1.1, fontWeight: 500 }}>
          {heroContent.title}
        </h1>
        <p 
          style={{ 
            fontSize: 'clamp(1.125rem, 1.9vw, 1.375rem)',
            color: 'rgba(255, 255, 255, 0.95)',
            marginBottom: '16px',
            fontWeight: 400,
            maxWidth: '800px',
            margin: '0 auto 16px',
            letterSpacing: '0.01em'
          }}
        >
          {heroContent.subtitle}
        </p>
        <p 
          style={{ 
            fontSize: 'clamp(0.9375rem, 1.5vw, 1.0625rem)',
            color: 'rgba(255, 255, 255, 0.85)',
            fontWeight: 300,
            maxWidth: '700px',
            margin: '0 auto',
            letterSpacing: '0.02em',
            lineHeight: 1.6
          }}
        >
          {heroContent.description}
        </p>
      </div>

      {/* Scroll Indicator */}
      <div className="scroll-indicator">
        <div className="scroll-line" />
      </div>
    </section>
  );
};

export default HeroSection;
